function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey2, grey5, spacing8, spacing16, spacing24, spacing48, boxShadowRaised } from "@churchofjesuschrist/eden-style-constants";
import { Clear } from "@churchofjesuschrist/eden-icons";
import { Icon as EdenIconButton } from "@churchofjesuschrist/eden-buttons";
import { mediaBreak600w } from "@churchofjesuschrist/eden-styled-helpers";
import { Text3 } from "@churchofjesuschrist/eden-text";
import Row from "@churchofjesuschrist/eden-row";
const Wrapper = styled.div.withConfig({
  componentId: "sc-75gd07-0"
})(["display:flex;align-items:flex-start;justify-content:space-between;width:100%;background-color:", ";box-shadow:", ";", ";padding:", ";padding-inline-start:", ";", ";"], grey2, boxShadowRaised, props => `border-bottom: 4px solid ${props.color}`, spacing16, spacing8, mediaBreak600w`
     padding-inline-start: ${spacing48};
  `);
const Content = styled.div.withConfig({
  componentId: "sc-75gd07-1"
})(["display:flex;align-items:flex-start;justify-content:center;width:100%;"]);
const IconWrapper = styled.span.withConfig({
  componentId: "sc-75gd07-2"
})(["display:inline-flex;margin-inline-end:", ";"], spacing8);
const Container = styled.div.withConfig({
  componentId: "sc-75gd07-3"
})(["display:flex;align-items:flex-start;flex-direction:column;", ";"], mediaBreak600w`
    flex-direction: row;
  `); // The margin-top is to pull the action buttons up to properly align with the text
// The margin-bottom of -3p is related... so the buttons don't expand the height of the "content area"
// Overall, a small button, which is the intended "Action" content, is 4px too large) so the
// top and bottom margins must be tweaked together.

const negativeFourPixels = "-4px";
const negativeThreePixels = "-3px";
const Actions = styled(Row).withConfig({
  componentId: "sc-75gd07-4"
})(["margin-block-start:", ";", ";flex-wrap:nowrap;"], spacing16, mediaBreak600w`
		margin-top: ${negativeFourPixels};
    margin-bottom: ${negativeThreePixels};
    margin-inline-start: ${spacing24};
  `); // The close button is 15px too large. The top & bottom margins of -8px & -7px is
// to prevent the close button from expanding the height of the "content area".

const negativeEightPixels = "-8px";
const negativeSevenPixels = "-7px";
const CloseButton = styled(EdenIconButton).withConfig({
  componentId: "sc-75gd07-5"
})(["display:inline-flex;background:transparent;cursor:pointer;margin-block-start:", ";margin-block-end:", ";margin-inline-start:", ";", ";&:hover{background:", ";}"], negativeEightPixels, negativeSevenPixels, spacing16, mediaBreak600w`
    margin-inline-start: ${spacing24};
  `, grey5);

const Banner = _ref => {
  let {
    color,
    Icon,
    title,
    description,
    action,
    onClose,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    color: color
  }, props), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Icon, {
    size: spacing24,
    color: color
  })), action ? /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Text3, null, title ? /*#__PURE__*/React.createElement("b", null, title) : null, " ", description), /*#__PURE__*/React.createElement(Actions, {
    columnGapSize: "8",
    rowGapSize: "0",
    verticalAlign: "start"
  }, action)) : /*#__PURE__*/React.createElement(Text3, null, title ? /*#__PURE__*/React.createElement("b", null, title) : null, " ", description)), onClose ? /*#__PURE__*/React.createElement(CloseButton, {
    onClick: e => onClose(e)
  }, /*#__PURE__*/React.createElement(Clear, {
    size: spacing24
  })) : null);
};

Banner.propTypes = {
  color: PropTypes.string.isRequired,
  Icon: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  action: PropTypes.element,
  onClose: PropTypes.func
};
export default Banner;